import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, debounceTime, filter, Observable, startWith } from 'rxjs';
import { PhoneService } from 'src/app/shared/services/phone.service';
import { Phone } from 'src/app/shared/models/phone';

@Component({
  selector: 'app-order-display',
  templateUrl: './order-display.component.html',
  styleUrls: ['./order-display.component.scss']
})
export class OrderDisplayComponent implements OnInit {

  readonly phones$: BehaviorSubject<Phone[]> = new BehaviorSubject<Phone[]>([]);
  filtredPhones: Phone[] = [];
  search: FormControl = new FormControl('');


  constructor(private readonly phoneService: PhoneService) { }

  ngOnInit(): void {
    this.getAllPhones();
    this.search.valueChanges.pipe(startWith(''), debounceTime(300)).subscribe(searchValue => {
      this.phones$.next(searchValue ? this.filtredPhones.filter(phone => JSON.stringify(phone).toLowerCase().includes(searchValue.toLowerCase())) : this.filtredPhones);
    });
  }

  getAllPhones() {
    this.phoneService.findAll().subscribe((phones: Phone[]) => {
      this.phones$.next(phones);
      this.filtredPhones = this.phones$.getValue();
    });
  }

}
